import { HeaderDataItem } from '@interfaces/models/header';
import useWindowSize from '@hooks/use-window-size';
import { MEN_UNIVERSE, WOMEN_UNIVERSE } from '@constants/user-shopping-preferences';
import { useTranslation } from 'next-i18next';
import { useShoppingPreferences } from '@hooks/user/use-shopping-preferences';
import clsx from 'clsx';
import styles from '../main-navigation.module.scss';
import NavigationItem from './navigation-link';

interface NewHomepageEntryProps {
  headerDataItem: HeaderDataItem;
  isMobile?: boolean;
  onClick: (label: string) => void;
}

const NewHomepagesEntry: React.FC<NewHomepageEntryProps> = (props) => {
  const { headerDataItem, isMobile = false, onClick } = props;
  const { isWiderThanLg } = useWindowSize();
  const { shoppingPrefEnable, setSessionPreferences } = useShoppingPreferences();
  const { t } = useTranslation('default-layout');
  const isWomenMenu = headerDataItem?.mnemonic === 'femme';
  const isMenMenu = headerDataItem?.mnemonic === 'homme';
  const showNewHomepage = shoppingPrefEnable && (isMenMenu || isWomenMenu);
  const womenLocalizedName = isMobile
    ? t('HEADER.NAVIGATION.HP.WOMENSWEAR_MOBILE')
    : t('HEADER.NAVIGATION.HP.WOMENSWEAR');
  const menLocalizedName = isMobile ? t('HEADER.NAVIGATION.HP.MENSWEAR_MOBILE') : t('HEADER.NAVIGATION.HP.MENSWEAR');
  const newHeader = {
    id: isWomenMenu ? 11111 : 22222,
    universeId: isWomenMenu ? WOMEN_UNIVERSE : MEN_UNIVERSE,
    localizedName: isWomenMenu ? womenLocalizedName : menLocalizedName,
    url: {
      anchor: isWomenMenu ? '/womenswear' : '/menswear',
      original: null,
      seo: isWomenMenu ? '/womenswear' : '/menswear',
    },
    mnemonic: isWomenMenu ? 'womenswear' : 'menswear',
  };

  const handleClick = (universe: number) => {
    setSessionPreferences({
      universe: universe,
      categories: [],
      custom: [],
    });
    onClick(universe === WOMEN_UNIVERSE ? 'womenswear' : 'menswear');
  };

  if (!showNewHomepage) {
    return false;
  }

  if (isWiderThanLg) {
    return (
      <div className={styles.desktop__linksContainer}>
        <h3>
          <a href="/">{t('HEADER.NAVIGATION.HP.TITLE')}</a>
        </h3>
        <ul className={clsx(styles.desktop__linkList)}>
          <li key={newHeader?.id}>
            <NavigationItem
              headerDataItem={newHeader}
              onClick={() => handleClick(newHeader.universeId)}
            />
          </li>
        </ul>
      </div>
    );
  } else {
    return (
      <li className={clsx(styles.mobile__linkListItem, styles['mobile__linkListItem--newHP'])}>
        <NavigationItem
          headerDataItem={newHeader}
          level={2}
          onClick={() => handleClick(newHeader.universeId)}
        />
      </li>
    );
  }
};

export default NewHomepagesEntry;
